<template lang="pug">
  .numbers
    h2 {{ i18n('numbers') }}
    ul.boxed
      li(
        v-for="group in grouped" :key="group.id"
        )
        h3 {{ group.id }}
        div.filled-chart
          .bar(:style="{ width: `${Math.round(group.events.length / group.years.length * 100)}%` }")
          .pointer(:style="{ left: `${Math.round(totalFilled * 100)}%` }")
        ul.boxed.elements
          li(
            v-for="number in group.numbers.filter(d => !!d.keys.length)"
            :key="number.id"
            :class="`element-${number.id}`"
            )
            h4 {{ number.title }} – {{ number.symbol }} ({{ number.events.length }})
            p {{ number.shells }}
            ul.boxed.keys
              li(
                v-for="key in number.keys" :key="key.key"
                :class="`element-${number.id}`"
                )
                h5 {{ key.title[locale] }} ({{ key.events.length }})
                p
                  rich-text-renderer(:document="key.description[locale]")
          li.overflow
            ul.overflow-list
              li.plus +
              li(v-for="number in group.numbers.filter(d => !d.keys.length)") {{ number.title }}
</template>

<script>
import RichTextRenderer from 'contentful-rich-text-vue-renderer'

import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'numbers',
  components: {
    RichTextRenderer
  },
  created() {
    this.listNumbers();
    this.listEvents();
  },
  computed: {
    ...mapGetters('locale', ['i18n']),
    ...mapState('locale', ['locale']),
    ...mapState('events', ['events']),
    ...mapState('weekdays', ['keys', 'numbers', 'elements', 'colors']),
    totalFilled() {
      return this.events.length / Object.keys(this.keys.year).length;
    },
    grouped() {
      return new Array(7)
        .fill(0)
        .map((_, i) => {
          const id = i;
          const years = Object.keys(this.keys.year)
            .filter(s => this.keys.year[s] === id)
            .map(s => parseInt(s, 10));

          const numbers = Object.keys(this.elements)
            .filter(s => parseInt(s, 10) % 7 === id)
            .map(s => {
              const number = parseInt(s, 10);
              const color = this.colors[number];
              const keys = this.numbers
                .filter(d => d.value === number)
                .map(({ key, title, data }) => ({
                  key,
                  title,
                  description: data.description,
                  events: [
                    ...new Set(
                      this.events
                        .filter(t => t.key === key)
                        .map(t => t.year)
                    )
                  ]
                }));
              return Object.assign(
                this.elements[s],
                {
                  id: number,
                  color,
                  events: [
                    ...new Set(keys.reduce((t, { events }) => t.concat(events || []), []))
                  ],
                  keys
                }
              );
            });
          return {
            id,
            numbers,
            years,
            events: [
              ...new Set(numbers.reduce((d, { events }) => d.concat(events || []), []))
            ]
          };
        });
    }
  },
  methods: {
    ...mapActions('weekdays', ['listNumbers']),
    ...mapActions('events', ['listEvents'])
  }
}
</script>

<style lang="stylus" scoped>

  .nnumbers
    margin 1rem

  ul.boxed
    margin 0
    padding 0
    list-style none
    display flex
    flex-wrap wrap

    li
      flex 1 1 80%
      box-sizing: border-box;
      margin 0 .5rem .5rem
      padding 1rem
      box-shadow 5px 5px 5px rgba(0, 0, 0, .1)
      &:first-child
        margin-top .5rem

      h5
        margin 0

  ul.elements, ul.keys
    background rgba(0, 0, 0, .15)
    box-shadow 5px 5px -5px rgba(0, 0, 0, .1)

  ul.keys li
    padding .5rem
    margin 0 .25rem .25rem
    &:first-child
      margin-top .25rem

  div.filled-chart
    background #ab565c
    height 1rem
    position relative
    margin .5rem 0
    .bar, .pointer
      position absolute
      top 0
    .pointer
      margin-left -8px
      background transparent
      width 0
      height 0
      border-left 8px solid transparent
      border-right 8px solid transparent
      border-top 8px solid var(--background-color)
      @media (prefers-color-scheme: dark)
        border-top 8px solid var(--background-color-dark)

    .bar
      background #54ab47
      bottom 0
      left 0
      border-right 1px solid var(--background-color)
      @media (prefers-color-scheme: dark)
        border-right 1px solid var(--background-color-dark)

  ul li.overflow
    margin 0
    padding 0
    background transparent
    box-shadow none

  ul.overflow-list
    margin 0 0 0 .5rem
    padding 0
    list-style none
    background transparent
    text-align left
    box-shadow none
    li
      display inline-block
      padding .25rem
      margin-left 0
      background var(--background-color)
      @media (prefers-color-scheme: dark)
        background var(--background-color-dark)
      &.plus
        width 1.8rem
        height 1.8rem
        border-radius 1.8rem
        text-align center
        font-weight bold
        background #54ab47
        color white
      &, &:first-child
        margin-top 0
</style>
